<template>
  <div>
    <ModalTemplate :showModal="isModalActive" :width="widthModal" @closeModal="closeModal">
      <template v-slot:headerModal>
        <div class="is-flex is-justify-content-space-between is-align-items-center">
          <div class="is-flex is-justify-content-space-between is-align-items-center">
            <EditSquare color="#ffffff" class="mr-2" size="23" />
            <p class="averta-bold label-18">
              {{ isSM ? 'Foto Before-After' : 'Ubah Status Absen' }}
            </p>
          </div>
          <div class="is-clickable" @click="closeModal">
            <!-- <b-icon icon="close"></b-icon> -->
             <XMarkIcon />
          </div>
        </div>
      </template>
      <template v-slot:bodyModal>
        <div class="wrap-body-modal">
          <!-- ALERT -->
          <div v-if="isSM" class="px-3 py-2 flex-center-vertical" style="background-color: #E8F4FD;">
            <AlertIcon color="#0080FF" />
            <p class="ml-2 line-height-16 averta-bold label-13" style="color: #0080FF;">Status absen hanya bisa diubah tukang melalui aplikasi tukang.</p>
          </div>
          <div v-else class="bg-pink-3 px-3 py-2 flex-center-vertical">
            <AlertIcon />
            <p class="color-red ml-2 line-height-16 averta-bold label-13">Perubahan status absen secara manual akan mempengaruhi riwayat progress untuk proyek ini pada halaman Report Progress</p>
          </div>

          <!-- HEADER -->
          <div class="layout-header">
            <!-- Wrap Detail Tukang -->
            <div class="tukang-wrapper" v-if="dataWorkerAbsent">
              <!-- Worker Data -->
              <div class="header-tukang">
                <div class="is-flex is-align-items-center mb-4"
                :class="{'cursor-pointer': dataWorkerAbsent && dataWorkerAbsent.certificates && dataWorkerAbsent.certificates.length > 0 }"
                @click="dataWorkerAbsent && dataWorkerAbsent.certificates && dataWorkerAbsent.certificates.length > 0 ?
                 handleOpenModalsPreviewSertifikat(dataWorkerAbsent.worker_id, dataWorkerAbsent) : '-' ">
                  <!-- Image Worker -->
                  <div class="tukang-img flex-center mr-3">
                    <img :src="dataWorkerAbsent.worker_image" alt="worker-image" />
                  </div>
                  <!-- Image Worker -->

                  <!-- Skill & Name Worker -->
                  <div class="wrapper-skill-name">
                    <div class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center">
                      <p class="averta-bold mb-1">{{ dataWorkerAbsent.worker_name }}</p>
                      <div class="badge-new-comment ml-3 gap-1"
                      v-if="dataWorkerAbsent && dataWorkerAbsent.certificates && dataWorkerAbsent.certificates.length > 0">
                        <SertifikatBadgeIcon />
                        <p class="m-0 label-10 averta-bold-italic color-green">
                          Bersertifikat
                        </p>
                      </div>
                    </div>
                    <div class="is-flex is-align-items-center">
                      <img :src="dataWorkerAbsent.skill_image" :alt="dataWorkerAbsent.skill_name" class="skill-img" />
                      <p>{{ dataWorkerAbsent.skill_name }}</p>
                      <p class="mx-2">&#8226;</p>
                      <p class="text-grey"><i>ID{{ dataWorkerAbsent.worker_id }}</i></p>
                    </div>
                  </div>
                  <!-- Skill & Name Worker -->
                </div>
              </div>
              <!-- Worker Data -->
              <!-- Status Tukang -->
              <div class="slot-wrapper">
                <div class="is-flex is-align-items-center">
                  <p class="averta-bold label-14 mr-2">Slot</p>
                  <p class="ml-5 mr-1 text-grey">:</p>
                  <p class="averta-reguler label-14 text-grey">
                    {{ formatDate(dataWorkerAbsent.selected_data) }}
                  </p>
                </div>
                <div class="is-flex is-align-items-center">
                  <p class="averta-bold label-14">Status</p>
                  <p class="ml-4 mr-1 text-grey">:</p>
                  <p class="averta-reguler label-14 text-grey">
                    {{ dataWorkerAbsent.attendance_status ? 'Hadir' : 'Tidak Hadir' }}
                  </p>
                </div>
              </div>
              <!-- Status Tukang -->
            </div>
            <!-- Wrap Detail Tukang -->
          </div>
          <!-- END HEADER -->
          <!-- BODY -->
          <div class="wrapper-body">
            <div v-if="!isSM" class="wrapper-status-hour" :style="[isMobile ? {} : { 'border-right': '6px solid rgba(225, 225, 225, 1)' }]">
              <div class="py-4 px-4">
                <p class="averta-black label-14">Pilih Status Baru</p>
                <div class="is-flex is-flex-direction-column p-3 wrapper-radio">
                  <b-field>
                    <b-radio v-model="absent" :native-value=true type="is-info">
                      <p class="averta-reguler label-14 color-black-primary">
                        Hadir
                      </p>
                    </b-radio>
                  </b-field>
                  <b-field>
                    <b-radio v-model="absent" :native-value=false type="is-info">
                      <p class="averta-reguler label-14 color-black-primary">
                        Tidak Hadir
                      </p>
                    </b-radio>
                  </b-field>
                </div>
              </div>
              <div class="py-4 px-4">
                <p class="averta-black label-14">Jam Kehadiran</p>
                <div class="text-input-wrapper" :class="{'isDisabled' : !isDisabledTime}">
                  <ClockCircle />
                  <input
                    type="time"
                    class="averta-bold ml-2 no-clock-icon"
                    v-model="time"
                    @input="handleInputTime"
                    :disabled="!isDisabledTime"
                  />
                </div>
              </div>
            </div>
            <!-- Non-SM Empty State -->
            <div v-if="!isSM && !absent && isAllPhotoBeforeEmpty" class="wrapper-empty">
              <div class="content-empty">
                <ProyekEmptyIcon width="120" height="120" />
                <div>
                  <p class="averta-bold label-14 color-black-primary">
                    Untuk upload foto before-after, ubah status kehadiran menjadi “Hadir”
                  </p>
                </div>
              </div>
            </div>
            <!-- SM Empty State (Worker Not Present) -->
            <div v-else-if="isSM && !isWorkerPresent" class="wrapper-empty" :style="[isMobile ? {} : { width: '100%' }]">
              <div class="content-empty">
                <ProyekEmptyIcon width="120" height="120" />
                <div>
                  <p class="averta-bold label-14 color-black-primary">
                    Foto before-after bisa diupload setelah tukang absen dari aplikasi.
                  </p>
                </div>
              </div>
            </div>
            <!-- Upload Area -->
            <div v-else-if="(!isSM && (absent || !isAllPhotoBeforeEmpty)) || (isSM && isWorkerPresent)" class="wrapper-upload p-3" :style="[isSM && !isMobile ? { width: '100%' } : {}]">
              <div>
                <p class="label-16"><span class="averta-black">Upload Foto Pengerjaan Proyek</span> <span class="color-grey">| Maks. {{ maxPhotoCount }} Foto</span></p>
                <p class="is-italic color-blue-1 label-12">*Pastikan foto sesudah berpasangan dengan foto sesudahnya</p>
              </div>
              <div class="is-flex mt-3">
                <div class="mr-3">
                  <div class="border-top-dotted">
                    <div class="is-flex is-align-items-center is-justify-content-center">
                      <div v-if="absent || !isAllPhotoBeforeEmpty">
                        <div v-for="(photoItem, idx) in dataFotoBefore" :key="idx" class="mb-3">
                          <p class="mb-2 label-14"> {{ getPhotoTitle(idx, 'before') }} </p>
                          <div class="wrapper-preview is-relative">
                            <div
                              v-if="photoItem.can_delete && absent"
                              class="x-mark-rounded cursor-pointer"
                              @click="handleDeletePhoto({ idx, status: 'before' })"
                            >
                              <img :src="require('@/assets/img/close-circle.png')" alt="delete-image" />
                            </div>
                            <div
                              v-if="photoItem.preview"
                              class="wrapper-add-file is-relative"
                              :class="{ 'cursor-pointer': absent }"
                            >
                              <img :src="photoItem.preview" alt="">
                            </div>
                            <div v-else-if="!photoItem.preview ">
                              <img v-if="!absent" src="@/assets/img/upload-photo-disable.png" alt="">
                              <label v-else class="cursor-pointer" for="beforeFoto">
                                <input
                                  id="beforeFoto"
                                  ref="beforeFoto"
                                  type="file"
                                  @change="e => handleFileUpload(e, 'before')"
                                  accept="image/*"
                                  hidden
                                />
                                <img @click="handleTempIndex(idx)" :src="require('@/assets/img/upload-photo.png')" alt="" />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="border-top-dotted">
                    <div class="is-flex is-align-items-center is-justify-content-center">
                      <div v-if="absent || !isAllPhotoBeforeEmpty">
                        <div v-for="(photoItem, idx) in dataFotoAfter" :key="idx" class="is-relative mb-3">
                          <!-- <p class="mb-2 label-14">Foto Sebelum Dekat</p> -->
                          <p class="mb-2 label-14"> {{ getPhotoTitle(idx, 'after') }} </p>
                          <div class="wrapper-preview is-relative">
                            <div
                              v-if="photoItem.can_delete && absent"
                              class="x-mark-rounded cursor-pointer"
                              @click="handleDeletePhoto({ idx, status: 'after' })"
                            >
                              <img :src="require('@/assets/img/close-circle.png')" alt="delete-image" />
                            </div>
                            <div
                              v-if="photoItem.preview"
                              class="wrapper-add-file is-relative"
                              :class="{ 'cursor-pointer': absent }"
                              @mouseenter="hoveredIdAfter = idx"
                              @mouseleave="hoveredIdAfter = null"
                            >
                              <img :src="photoItem.preview" alt="">
                              <label :for="'input-file-after-' + idx" v-if="hoveredIdAfter === idx" class="edit-photo-before-after">
                                <EditIcon color="#ffffff" />
                              </label>
                              <input
                                :id="'input-file-after-' + idx"
                                type="file"
                                class="d-none"
                                ref="clientImg"
                                @change="uploadImageFile($event, 'after', idx)"
                                hidden
                                accept="image/png, image/jpeg"
                                />
                            </div>
                            <div v-else-if="!photoItem.preview">
                              <img v-if="photoItem.disabled || !absent" src="@/assets/img/upload-photo-disable.png" alt="">
                              <label v-else class="cursor-pointer" for="afterFoto">
                                <input
                                  id="afterFoto"
                                  ref="afterFoto"
                                  type="file"
                                  @change="e => handleFileUpload(e, 'after', idx)"
                                  accept="image/*"
                                  hidden
                                />
                                <img @click="handleTempIndex(idx)" :src="require('@/assets/img/upload-photo.png')" alt="" />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END BODY -->
        </div>

        <!-- Floating Button -->
        <div class="wrapper-footer-btn" v-if="!isSM || isWorkerPresent">
          <ButtonApp :isSecondary="false" :isBold="true" width="150px" height="46px" @click="handleSubmit">
            Simpan Perubahan
          </ButtonApp>
        </div>
        <!-- Floating Button -->

        <!-- Loading -->
        <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false">
          <SpinnerIcon />
        </b-loading>
        <!-- Loading -->
      </template>
    </ModalTemplate>

    <ModalsPreviewSertifikat
      :isHandleOpenModalsPreviewSertifikat="isHandleOpenModalsPreviewSertifikat"
      :selectWorkers="selectWorkers"
      @closeModalPreviewSertifikat="closeModalPreviewSertifikat"
    />

    <modalEditPhotoBeforeAfter
      :isHandleOpenModalEditPhoto="isHandleOpenModalEditPhoto"
      :previewImage="preview_crop"
      :closeModalEdtitPhoto="closeModalEdtitPhoto"
      :imageId="editingImageId"
      :imageData="editingImageData"
      :imageType="editingType"
      :imageHeight="editingImageData ? editingImageData.height : 0"
      :imageWidth="editingImageData ? editingImageData.width : 0"
      @cropImage="cropImage($event)"
      @resetPreviewImage="preview_crop = ''"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import Compressor from 'compressorjs'
import { alertErrorMessage } from '@/helpers'
import ButtonApp from '@/components/button/ButtonApp'
import { EditSquare, ProyekEmptyIcon, ClockCircle, SpinnerIcon, AlertIcon, SertifikatBadgeIcon, XMarkIcon, EditIcon } from '@/components/icons'
import confirmOfferingImage from '@/assets/img/delete-area-component.png'
import ModalsPreviewSertifikat from '@/components/modal/ModalsPreviewSertifikat.vue'
import modalEditPhotoBeforeAfter from '@/components/modal/ModalEditPhotoBeforeAfter'

export default {
  name: 'ModalChangeAttandance',
  data () {
    return {
      isLoading: false,
      absent: null,
      maxPhotoCount: 2,
      isMobile: false,
      isModalActive: false,
      widthModal: this.width,
      isButtonUploadBefore: null,
      isButtonUploadAfter: null,
      dataFotoBefore: [
        {
          preview: null,
          picture: null,
          can_delete: false
        },
        {
          preview: null,
          picture: null,
          can_delete: false
        }
      ],
      dataFotoAfter: [
        {
          preview: null,
          picture: null,
          can_delete: false,
          disabled: true
        },
        {
          preview: null,
          picture: null,
          can_delete: false,
          disabled: true
        }
      ],
      time: null,
      isDisabledTime: false,
      jobId: null,

      alreadyUploadBefore: false,
      alreadyUploadAfter: false,
      tempIndex: null,
      isHandleOpenModalsPreviewSertifikat: false,
      selectWorkers: {},
      imageBeforeFileIndexes: [],
      isHandleOpenModalEditPhoto: false,
      hoveredIdAfter: false,
      hoveredIdBefore: false,
      preview_crop: null,
      imagePreview: null,
      editingType: null,
      editingIndex: null,
      editingImageId: null,
      editingImageData: null
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '53vw'
    },
    dataWorkerAbsent: {
      type: Object,
      default: () => {
        return {}
      }
    }
    // selectWorkers: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   }
    // }
  },
  components: {
    ButtonApp,
    EditSquare,
    // eslint-disable-next-line vue/no-unused-components
    ProyekEmptyIcon,
    ClockCircle,
    SpinnerIcon,
    AlertIcon,
    ModalTemplate: () => import('@/components/modal/ModalTemplate'),
    SertifikatBadgeIcon,
    ModalsPreviewSertifikat,
    XMarkIcon,
    modalEditPhotoBeforeAfter,
    EditIcon
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      user: 'auth/user'
    }),
    isSM () {
      const isRoleSM = Boolean(this.user && this.user.roles && this.user.roles[0] && this.user.roles[0].name === 'Site Manager')
      const isRouteSM = Boolean(this.$route && this.$route.path && this.$route.path.includes('/sm/'))
      return isRoleSM || isRouteSM
    },
    isWorkerPresent () {
      return Boolean(this.dataWorkerAbsent && this.dataWorkerAbsent.attendance_status)
    },
    isAllPhotoBeforeEmpty () {
      return this.dataFotoBefore.every(item => !item.preview)
    }
  },
  watch: {
    showModal (newValue) {
      this.isModalActive = newValue
    },
    width (newValue) {
      this.widthModal = newValue
    },
    absent (value) {
      if (!value) {
        this.isDisabledTime = false
        this.isButtonUploadBefore = false
        this.isButtonUploadAfter = false
      } else {
        this.isDisabledTime = true
        this.isButtonUploadBefore = true
        this.isButtonUploadAfter = true
      }
    },
    dataWorkerAbsent (newVal) {
      this.absent = newVal.attendance_status
      this.jobId = newVal.job_id

      const responseTime = newVal.attendance_date === null ? new Date() : newVal.attendance_date
      this.time = moment(responseTime).format('HH:mm')

      if (newVal.image_photo_before && newVal.image_photo_before.length > 0) {
        this.convertUrlToBlob(newVal.image_photo_before, 'before')

        setTimeout(() => {
          if (newVal.image_photo_after && newVal.image_photo_after.length > 0) {
            this.convertUrlToBlob(newVal.image_photo_after, 'after')
          }
        }, 100)
      }

      setTimeout(() => {
        for (let i = 0; i < newVal.image_photo_before.length; i++) {
          const value = JSON.stringify(newVal.image_photo_before[i])

          if (value !== '{}' && !this.imageBeforeFileIndexes.includes(i)) {
            this.imageBeforeFileIndexes.push(i)
          }
        }
      }, 300)
    },
    dataFotoBefore (val) {
      val.forEach((item, index) => {
        if (!item.preview) {
          const data = {
            preview: null,
            picture: null,
            can_delete: false,
            disabled: true
          }
          this.dataFotoAfter.splice(index, 1, data)
        }
      })
    }
  },
  methods: {
    handleInputTime (event) {
      if (!event.target.value) {
        this.time = null
      }
    },
    clearData () {
      this.dataFotoBefore = [
        {
          preview: null,
          picture: null,
          can_delete: false
        },
        {
          preview: null,
          picture: null,
          can_delete: false
        }
      ]
      this.dataFotoAfter = [
        {
          preview: null,
          picture: null,
          can_delete: false,
          disabled: true
        },
        {
          preview: null,
          picture: null,
          can_delete: false,
          disabled: true
        }
      ]
      this.absent = null
      this.jobId = null
      this.time = null
      this.imageBeforeFileIndexes = []
    },
    checkScreenSize () {
      this.isMobile = window.innerWidth < 768
    },
    closeModal () {
      this.clearData()
      this.$emit('closeModal')
    },
    handleDeletePhoto (data = {}) {
      const { status, idx } = data
      if (status === 'before') {
        this.imageBeforeFileIndexes = this.imageBeforeFileIndexes.filter(num => num !== idx)
      }

      const photoArray = status === 'before' ? this.dataFotoBefore : this.dataFotoAfter
      const uploadButton = status === 'before' ? this.isButtonUploadBefore : this.isButtonUploadAfter

      const result = photoArray.splice(idx, 1, {
        preview: null,
        picture: null,
        can_delete: false
      })

      if (status === 'before') {
        const data = {
          ...this.dataFotoAfter[idx],
          disabled: true
        }
        this.dataFotoAfter.splice(idx, 1, data)
      }
      this[uploadButton] = !this.absent || photoArray.length >= this.maxPhotoCount

      return result
    },
    handleTempIndex (idx) {
      this.tempIndex = idx
    },
    async handleFileUpload (event, status, idx) {
      if (status === 'before') {
        this.imageBeforeFileIndexes.push(this.tempIndex)
      }

      const selectedFile = event.target.files[0]
      if (selectedFile) {
        const fileSizeInMB = selectedFile.size / (1024 * 1024)
        const allowedTypes = [
          'image/jpeg',
          'image/png',
          'image/jpg',
          'image/JPEG',
          'image/PNG',
          'image/JPG'
        ]

        // VALIDASI
        if (!allowedTypes.includes(selectedFile.type)) {
          this.$buefy.toast.open({
            message: 'Hanya file gambar yang diperbolehkan (JPEG, JPG, PNG)',
            type: 'is-danger'
          })
          return false
        }

        // VALIDASI
        if (fileSizeInMB.toFixed(2) > this.maxPhotoSizeMB) {
          this.$buefy.toast.open({
            message: 'Gambar melebihi ukuran maksimum yang diizinkan',
            type: 'is-danger'
          })
          return false
        }
      }

      if (status === 'before') {
        const fileURL = URL.createObjectURL(selectedFile)
        const dimensions = await this.getImageDimensions(fileURL)
        let width = dimensions.width
        let height = dimensions.height

        if (!width || !height || width === 0 || height === 0) {
          if (this.dataWorkerAbsent && this.dataWorkerAbsent.photos) {
            const photoArray = this.dataWorkerAbsent.photos[this.tempIndex]
            if (photoArray && photoArray.before) {
              width = photoArray.before.width || 0
              height = photoArray.before.height || 0
            }
          } else if (this.dataWorkerAbsent && this.dataWorkerAbsent.image_photo_before) {
            const imageArray = this.dataWorkerAbsent.image_photo_before
            if (imageArray && imageArray[idx]) {
              width = imageArray[idx].width || 0
              height = imageArray[idx].height || 0
            }
          }
        }

        await this.handleCompressImage(selectedFile).then(results => {
          const data = {
            preview: URL.createObjectURL(results),
            picture: results,
            can_delete: true,
            width: width,
            height: height
          }

          this.dataFotoBefore.splice(this.tempIndex, 1, data)
          this.$refs.beforeFoto.value = ''

          const dataAfter = {
            ...this.dataFotoAfter[this.tempIndex],
            disabled: false
          }
          this.dataFotoAfter.splice(this.tempIndex, 1, dataAfter)
        })
      } else {
        this.editingType = 'after'
        this.editingIndex = this.tempIndex

        const beforePhoto = this.dataFotoBefore[this.tempIndex]
        if (beforePhoto && beforePhoto.preview) {
          let width = beforePhoto.width || 0
          let height = beforePhoto.height || 0

          if (!width || !height || width === 0 || height === 0) {
            if (this.dataWorkerAbsent && this.dataWorkerAbsent.photos) {
              const photoArray = this.dataWorkerAbsent.photos[this.tempIndex]
              if (photoArray && photoArray.before) {
                width = photoArray.before.width || 0
                height = photoArray.before.height || 0
              }
            } else if (this.dataWorkerAbsent && this.dataWorkerAbsent.image_photo_before) {
              const imageArray = this.dataWorkerAbsent.image_photo_before
              if (imageArray && imageArray[this.tempIndex]) {
                width = imageArray[this.tempIndex].width || 0
                height = imageArray[this.tempIndex].height || 0
              }
            }
          }

          this.editingImageId = null
          this.editingImageData = {
            height: height,
            width: width
          }

          this.preview_crop = URL.createObjectURL(selectedFile)
          this.isHandleOpenModalEditPhoto = true
          this.$refs.afterFoto.value = ''
        } else {
          const fileURL = URL.createObjectURL(selectedFile)
          const dimensions = await this.getImageDimensions(fileURL)

          let width = dimensions.width
          let height = dimensions.height

          if (!width || !height || width === 0 || height === 0) {
            if (this.dataWorkerAbsent && this.dataWorkerAbsent.photos) {
              const photoArray = this.dataWorkerAbsent.photos[this.tempIndex]
              if (photoArray && photoArray.after) {
                width = photoArray.after.width || 0
                height = photoArray.after.height || 0
              }
            } else if (this.dataWorkerAbsent && this.dataWorkerAbsent.image_photo_after) {
              const imageArray = this.dataWorkerAbsent.image_photo_after
              if (imageArray && imageArray[this.tempIndex]) {
                width = imageArray[this.tempIndex].width || 0
                height = imageArray[this.tempIndex].height || 0
              }
            }
          }

          await this.handleCompressImage(selectedFile).then(results => {
            const data = {
              preview: URL.createObjectURL(results),
              picture: results,
              can_delete: true,
              width: width,
              height: height
            }

            this.dataFotoAfter.splice(this.tempIndex, 1, data)
            this.$refs.afterFoto.value = ''
          })
        }
      }

      if (this.dataFotoBefore.length === this.maxPhotoCount) {
        this.isButtonUploadBefore = true
      }

      if (this.dataFotoAfter.length === this.maxPhotoCount) {
        this.isButtonUploadAfter = true
      }
    },
    getImageDimensions (url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          resolve({
            width: img.width,
            height: img.height
          })
        }
        img.onerror = reject
        img.src = url
      })
    },
    handleSubmit () {
      if (!this.isSM) {
        if (this.absent === true && (this.time === 'Invalid date' || this.time === null)) {
          this.$buefy.toast.open({
            message: 'Masukkan jam kehadiran terlebih dahulu',
            type: 'is-danger'
          })
          return
        }
      } else {
        const hasBefore = this.dataFotoBefore.some(item => item.picture)
        const hasAfter = this.dataFotoAfter.some(item => item.picture)
        if (!hasBefore && !hasAfter) {
          this.$buefy.toast.open({
            message: 'Foto before atau after wajib diunggah',
            type: 'is-danger'
          })
          return
        }
      }

      const payload = {
        url: this.url,
        job_id: this.jobId,
        image_befores: this.dataFotoBefore,
        image_afters: this.dataFotoAfter,
        image_before_file_indexes: [...new Set(this.imageBeforeFileIndexes)].sort((a, b) => a - b)
      }

      if (!this.isSM) {
        payload.is_present = this.absent === true ? 1 : 0
        payload.attendance_time = this.time === 'Invalid date' ? null : this.time
      }

      this.$swal({
        imageUrl: confirmOfferingImage,
        imageAlt: 'confirm offering',
        width: '540px',
        padding: '10px 10px 30px 10px',
        title: '<p class="averta-bold label-22" style="margin-bottom: -10px;">Simpan Perubahan</p>',
        html: '<p class="averta-regular">Pastikan seluruh informasi yang diinginkan telah sesuai.</p>',
        showCancelButton: true,
        confirmButtonText: 'Simpan Perubahan',
        cancelButtonText: 'Batalkan',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn-hapus-detail-component',
          cancelButton: 'btn-batal-detail-component'
        }
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          try {
            const res = await this.$store.dispatch('projectV2/workerAttandance', payload)
            if (!res) {
              alertErrorMessage()
              this.isLoading = false
              this.$emit('reloadPage', this.dataWorkerAbsent.selected_data)
            } else {
              this.clearData()
              this.closeModal()
              this.isLoading = false
              this.$emit('reloadPage', this.dataWorkerAbsent.selected_data)
            }
            this.imageBeforeFileIndexes = []
          } catch (error) {
            alertErrorMessage(error)
            this.isLoading = false
            this.$emit('reloadPage', this.dataWorkerAbsent.selected_data)
          }
        } else if (result.dismiss === 'cancel') {
          // do nothing
        }
      }).catch((error) => {
        alertErrorMessage(error)
      })
    },
    formatDate (date) {
      if (!date) {
        return '-'
      }
      return moment(date).format('DD MMMM YYYY')
    },
    handleCompressImage (image) {
      return new Promise((resolve, reject) => {
        const compressor = new Compressor(image, {
          quality: 0.6,
          mimeType: 'image/jpeg',
          success (result) {
            resolve(result)
          },
          error (err) {
            console.error(err.message)
            reject(err)
          }
        })

        return compressor
      })
    },
    convertUrlToBlob (data, type) {
      if (type === 'before') {
        for (let i = 0; i < data.length; i++) {
          if (Object.keys(data[i]).length > 0) {
            fetch(data[i].image_url || data[i])
              .then(response => response.blob())
              .then(blob => {
                const body = {
                  preview: blob ? URL.createObjectURL(blob) : null,
                  picture: blob || null,
                  can_delete: !!blob
                }
                this.dataFotoBefore.splice(i, 1, body)

                const data = {
                  ...this.dataFotoAfter[i],
                  disabled: false
                }
                this.dataFotoAfter.splice(i, 1, data)
              })
          }
        }
      } else {
        for (let i = 0; i < data.length; i++) {
          if (Object.keys(data[i]).length > 0 && (data[i].image_url || data[i])) {
            fetch(data[i].image_url ? data[i].image_url : data[i])
              .then(response => response.blob())
              .then(blob => {
                const body = {
                  preview: blob ? URL.createObjectURL(blob) : null,
                  picture: blob || null,
                  can_delete: !!blob,
                  disabled: false

                }
                this.dataFotoAfter.splice(i, 1, body)
              })
          }
        }
      }
    },
    handleOpenModalsPreviewSertifikat (workersId, workers) {
      this.selectWorkers = { workersId, ...workers }
      this.isHandleOpenModalsPreviewSertifikat = true
    },
    closeModalPreviewSertifikat () {
      this.isHandleOpenModalsPreviewSertifikat = false
    },
    getPhotoTitle (index, type) {
      const titles = {
        before: ['Upload Foto Sebelum', 'Upload Foto Sebelum'],
        after: ['Upload Foto Sesudah', 'Upload Foto Sesudah']
      }
      return titles[type][index] || ''
    },
    uploadImageFile (e, type, idx) {
      e.preventDefault()
      if (e.target.files[0]) {
        this.editingType = type
        this.editingIndex = idx

        if (this.dataWorkerAbsent && this.dataWorkerAbsent.photos) {
          const photoArray = this.dataWorkerAbsent.photos[idx]
          if (photoArray) {
            if (type === 'after' && photoArray.after) {
              this.editingImageId = photoArray.after.id
              this.editingImageData = {
                ...photoArray.before,
                height: photoArray.before.height || 0,
                width: photoArray.before.width || 0
              }
            }
          }
        } else if (this.dataWorkerAbsent) {
          const imageArray = type === 'before'
            ? this.dataWorkerAbsent.image_photo_before
            : this.dataWorkerAbsent.image_photo_after

          if (imageArray && imageArray[idx]) {
            this.editingImageId = imageArray[idx].id
            this.editingImageData = {
              ...imageArray[idx],
              height: imageArray[idx].height || 0,
              width: imageArray[idx].width || 0
            }
          }
        }

        console.log('editingImageData', this.editingImageData)
        console.log('dataWorkerAbsent', this.dataWorkerAbsent)
        this.preview_crop = URL.createObjectURL(e.target.files[0])
        this.isHandleOpenModalEditPhoto = true
        e.target.value = ''
      }
    },
    closeModalEdtitPhoto () {
      this.isHandleOpenModalEditPhoto = false
    },
    cropImage (result) {
      const { preview, file, height, width } = result
      if (this.editingType === 'before') {
        const updatedPhoto = {
          preview: preview,
          picture: file,
          can_delete: true,
          id: this.editingImageId,
          height: height || (this.editingImageData ? this.editingImageData.height : 0),
          width: width || (this.editingImageData ? this.editingImageData.width : 0)
        }
        this.dataFotoBefore.splice(this.editingIndex, 1, updatedPhoto)
        const dataAfter = {
          ...this.dataFotoAfter[this.editingIndex],
          disabled: false
        }
        this.dataFotoAfter.splice(this.editingIndex, 1, dataAfter)
      } else if (this.editingType === 'after') {
        const updatedPhoto = {
          preview: preview,
          picture: file,
          can_delete: true,
          disabled: false,
          id: this.editingImageId,
          image_before_id: this.editingImageData ? this.editingImageData.image_before_id : null,
          height: height || (this.editingImageData ? this.editingImageData.height : 0),
          width: width || (this.editingImageData ? this.editingImageData.width : 0)
        }
        this.dataFotoAfter.splice(this.editingIndex, 1, updatedPhoto)
      }

      this.imagePreview = preview
      this.imgFile = file
      this.isHandleOpenModalEditPhoto = false
    }
  },
  mounted () {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  },
  created () { },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScreenSize)
  }
}
</script>

<style scoped>
.content-empty {
  width: 280px;
  margin: auto;
}

.wrapper-empty {
  width: 65%;
  height: 230px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.wrap-body-modal {
  height: 480px;
  overflow-y: auto;
  position: relative;
}

.layout-header {
  padding: 12px 32px;
  background: rgba(16, 189, 65, 0.1);
}

.wrapper-body {
  display: flex;
  flex-direction: row;
  /* padding-bottom: 75px; */
}

.wrapper-body>* {
  flex-grow: 1;
  overflow: auto;
}

.wrapper-footer-btn {
  position: relative;
  bottom: 0px;
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  background: white;
  padding: 12px 24px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.slot-wrapper {
  padding: 12px;
  border-radius: 12px;
  background: #ffffff;
}

.tukang-img {
  width: 50px;
  height: 50px;
  border-radius: 35px;
  overflow: hidden;
}

.tukang-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.skill-img {
  width: 34px;
  margin-right: 10px;
  border-radius: 35px;
}

.wrapper-skill {
  min-width: auto;
  margin-right: 1em;
}

.wrapper-id {
  min-width: 7.5em;
}

.wrapper-status-hour {
  width: 35%;
  padding: 15px, 30px, 15px, 30px;
}

.wrapper-upload {
  width: 65%;
  padding: 15px, 30px, 15px, 30px;
  height: 265px;
  overflow: auto;
}

.wrapper-radio {
  margin-top: 1rem;
  background: rgba(250, 250, 250, 1);
  border-radius: 12px;
}

.wrapper-hour {
  margin-top: 0.2rem;
}

.wrapper-add-file {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  width: 84px;
  height: 84px;
  position: relative;
}

.wrapper-add-file img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.input-time {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 10px;
  border: 1px solid #e1e1e1;
}

.text-input-wrapper {
  border: 1px solid #e1e1e1;
  padding: 10px 0px;
  padding-left: 1em;
  border-radius: 10px;
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 5px;
}

.text-input-wrapper input {
  border: none;
  outline: none;
  font-size: 16px;
  background: transparent;
}

.text-input-wrapper.isDisabled {
  pointer-events: none;
  background: #e1e1e1;
}

.no-clock-icon::-webkit-calendar-picker-indicator {
  display: none;
}

.wrapper-preview {
  width: 84px;
  height: 84px;
  overflow: hidden;
  margin: auto;
}

@media screen and (max-width: 600px) {
  .grid-container {
    grid-template-columns: 1fr;
  }
}
.badge-new-comment {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: auto;
  min-width: auto;
  max-width: auto;
  height: auto;
  margin: 0;
  padding: 0.25rem 0.5rem;
  background: #ffffff !important;
  border-radius: 1000px;
}

.edit-photo-before-after {
  position: absolute;
  right: 50%;
  top: 50%;
  transform: translate(50%, -50%);
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  height: 30px;
  min-height: 30px;
  max-height: 30px;
  margin: 0;
  padding: 0.5rem;
  border-radius: 50%;
  background: #E10009 !important;
}
</style>
